var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBinTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.08, 0) scale(1.385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.998698 10.9167C0.998698 11.65 1.5987 12.25 2.33203 12.25H7.66536C8.3987 12.25 8.9987 11.65 8.9987 10.9167V4.25C8.9987 3.51667 8.3987 2.91667 7.66536 2.91667H2.33203C1.5987 2.91667 0.998698 3.51667 0.998698 4.25V10.9167ZM8.9987 0.916667H7.33203L6.8587 0.443333C6.7387 0.323333 6.56536 0.25 6.39203 0.25H3.60536C3.43203 0.25 3.2587 0.323333 3.1387 0.443333L2.66536 0.916667H0.998698C0.632031 0.916667 0.332031 1.21667 0.332031 1.58333C0.332031 1.95 0.632031 2.25 0.998698 2.25H8.9987C9.36537 2.25 9.66537 1.95 9.66537 1.58333C9.66537 1.21667 9.36537 0.916667 8.9987 0.916667Z",
    fill: "#D0190F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBinTooltip);
export default __webpack_public_path__ + "static/media/icon-bin-tooltip.d3cb237d2c1228e3daa970195faac6fc.svg";
export { ForwardRef as ReactComponent };